import React from 'react';
import { FormattedMessage } from 'react-intl';

import FavoritePlans from './Plans/FavoritePlans';
import PreDocVerificationPlans from './Plans/PreDocVerificationPlans';
import EnrollmentPlans from './Plans/EnrollmentPlans';

const Enrollment = (props) => {
    const {
        data,
        type,
        onCTAHandler,
        showChangePlansLink,
        exceptionalCircumstanceCb,
        effectiveStartDate = null
    } = props;

    const handleClick = e => {
        e.preventDefault();
        onCTAHandler();
    };

    /**
     * Header to support state specific requirements.
     * @param type
     * @returns {*}
     * @constructor
     */
    const EnrollmentHeader = ({ type }) => {
        const HEALTH = 'Health';
        type = `${type[0].toUpperCase()}${type.slice(1).toLowerCase()}`;
        return <FormattedMessage 
            id="indportal.dashboard.plans.header" 
            values={{ planType: type == HEALTH ? <FormattedMessage id="plans.planType.health" /> :  <FormattedMessage id="plans.planType.dental" /> }}
        />;

    };

    /**
     * If there are no enrollments and no favorite plans, display default message.
     * Otherwise render enrollment's plans or favorite plans or saved plans (preDocVerification data).
     * @param data
     * @returns {*}
     */
    const getEnrollmentPlans = (data) => {
        const { enrollments, favPlans, preDocVerificationSavedPlans } = data;
        if (!data) {
            return (
                <div className="grid-row">
                    <div className="grid-col-12">
                        <FormattedMessage id={`indportal.dashboard.plans.${type && type.toLowerCase()}NoPlans`}/>
                    </div>
                </div>);
        }

        if (enrollments && enrollments.length > 0) { // pure enrollments
            return <EnrollmentPlans 
                {...data}
                type={type}
                handleClick={handleClick}
                showChangePlansLink={showChangePlansLink}
                exceptionalCircumstanceCb={exceptionalCircumstanceCb} 
            />;
        } else if (favPlans && favPlans.length > 0) { // fav plans
            return <FavoritePlans 
                {...data}
                type={type}
                handleClick={handleClick}
            />;
        } else if (preDocVerificationSavedPlans) { // saved plans
            return <PreDocVerificationPlans
                {...data}
                type={type}
                effectiveStartDate={effectiveStartDate}
                handleClick={handleClick}
            /> ;
        }
    };

    return (
        <div className="">
            <div className="grid-row">
                <h4 className="">
                    <EnrollmentHeader type={type}/>
                </h4>
            </div>
            { getEnrollmentPlans(data) }
        </div>);

};

export default Enrollment;